/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const bulkPatchItemErrorSchema = z.object({
  errorCode: z.enum(['NOT_FOUND', 'VALIDATION', 'CONFLICT', 'BATCH_FAILURE']),
  itemId: z.int(),
  message: z.string(),
});
